import { localesDomus_de, localesIs24_de } from '@smg-real-estate/domus';

import localesApp from './locales/de-CH.json';
import localesTheme from './locales/immoscout24-de-CH.json';

export default {
  ...localesDomus_de,
  ...localesIs24_de,
  ...localesTheme,
  ...localesApp,
};
